// Configurações de tamanho específicas para logos que precisam de ajustes individuais
export const LOGO_SIZE_OVERRIDES = {
  stone: {
    desktop: {width: 120, height: 65, fill: true},
    mobile: {width: 80, height: 45, fill: true}
  },
  ton: {
    desktop: {width: 100, height: 65, fill: true},
    mobile: {width: 80, height: 45, fill: true}
  },
  paygo: {
    desktop: {width: 130, height: 65, fill: true},
    mobile: {width: 80, height: 45, fill: true}
  },
  bin: {
    desktop: {width: 90, height: 65, fill: true},
    mobile: {width: 70, height: 45, fill: true}
  },
  pagseguro: {
    desktop: {width: 140, height: 65, fill: true},
    mobile: {width: 85, height: 45, fill: true}
  },
  cielo: {
    desktop: {width: 100, height: 65, fill: true},
    mobile: {width: 70, height: 45, fill: true}
  },
  mercadopago: {
    desktop: {width: 150, height: 65, fill: true},
    mobile: {width: 85, height: 45, fill: true}
  },
  afinz: {
    desktop: {width: 100, height: 65, fill: true},
    mobile: {width: 75, height: 45, fill: true}
  },
  sitef: {
    desktop: {width: 70, height: 65, fill: true},
    mobile: {width: 60, height: 45, fill: true}
  },
  unica: {
    desktop: {width: 110, height: 65, fill: true},
    mobile: {width: 70, height: 45, fill: true}
  },
  sicredi: {
    desktop: {width: 150, height: 65, fill: true},
    mobile: {width: 85, height: 45, fill: true}
  },
  sipag: {
    desktop: {width: 100, height: 65, fill: true},
    mobile: {width: 75, height: 45, fill: true}
  },
  azulzinha: {
    desktop: {width: 150, height: 65, fill: true},
    mobile: {width: 100, height: 45, fill: true}
  },
  adyen: {
    desktop: {width: 120, height: 65, fill: true},
    mobile: {width: 85, height: 45, fill: true}
  },
  vero: {
    desktop: {width: 120, height: 65, fill: true},
    mobile: {width: 85, height: 45, fill: true}
  },
  safrapay: {
    desktop: {width: 130, height: 65, fill: true},
    mobile: {width: 80, height: 45, fill: true}
  },
  rede: {
    desktop: {width: 100, height: 65, fill: true},
    mobile: {width: 70, height: 45, fill: true}
  },
  picpay: {
    desktop: {width: 130, height: 65, fill: true},
    mobile: {width: 80, height: 45, fill: true}
  },
  getnet: {
    desktop: {width: 130, height: 65, fill: true},
    mobile: {width: 80, height: 45, fill: true}
  },
  ifood: {
    desktop: {width: 110, height: 65, fill: true},
    mobile: {width: 80, height: 45, fill: true}
  },
  yuno: {
    desktop: {width: 100, height: 65, fill: true},
    mobile: {width: 70, height: 45, fill: true}
  },
  sumup: {
    desktop: {width: 130, height: 65, fill: true},
    mobile: {width: 85, height: 45, fill: true}
  },
  '99food': {
    desktop: {width: 90, height: 65, fill: true},
    mobile: {width: 70, height: 40, fill: true}
  },
  keeta: {
    desktop: {width: 80, height: 65, fill: true},
    mobile: {width: 70, height: 45, fill: true}
  },
  qlub: {
    desktop: {width: 100, height: 65, fill: true},
    mobile: {width: 70, height: 45, fill: true}
  },
  bs2adiq: {
    desktop: {width: 90, height: 50, fill: true},
    mobile: {width: 60, height: 35, fill: true}
  },
  xp: {
    desktop: {width: 100, height: 65, fill: true},
    mobile: {width: 70, height: 45, fill: true}
  }
};

const BREAKPOINT_MULTIPLIERS = {
  mobile: 1,
  xxs: 0.5,
  tablet: 0.65,
  smallDesktop: 0.9,
  desktop: 1
};

const getBreakpoint = () => {
  const width = window.innerWidth;
  if (width <= 600) return 'mobile';
  if (width <= 875) return 'xxs';
  if (width <= 1150) return 'tablet';
  if (width <= 1300) return 'smallDesktop';
  return 'desktop';
};

export const getLogoSize = (machineId, compact = false) => {
  const config = LOGO_SIZE_OVERRIDES[machineId];
  if (!config) return null;

  const breakpoint = getBreakpoint();
  const multiplier = BREAKPOINT_MULTIPLIERS[breakpoint];

  let baseSize;
  if (breakpoint === 'mobile') {
    baseSize = config.mobile;
  } else {
    baseSize = {
      width: Math.round(config.desktop.width * multiplier),
      height: Math.round(config.desktop.height * multiplier),
      fill: config.desktop.fill
    };
  }

  if (compact) {
    return {
      width: Math.round(baseSize.width * 0.7),
      height: Math.round(baseSize.height * 0.7),
      fill: baseSize.fill
    };
  }

  return baseSize;
};
